import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventType } from '../domain/event-type/event-type';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private event: EventType;
  private subject: BehaviorSubject<EventType>;

  constructor() {
    this.subject = new BehaviorSubject(this.event);
  }

  public onEvent$(): Observable<EventType> {
    return this.subject.asObservable();
  }

  public publishEvent(event: EventType) {
    // console.log("PUBLISH EVENT: ", event);
    this.subject.next(event);
  }
}
